import { SOLANA_NETWORK } from '@/providers/WalletProvider.tsx';

export const SCALE = 1_000_000;
export const DAY = SOLANA_NETWORK === 'mainnet-beta' ? 86_400 : 30;
export const LOCK_PERIODS = [14 * DAY, 30 * DAY, 90 * DAY];
